module.exports = __webpack_public_path__ + "media/thieme/Janis_Plastic-Surgery-Flashcards_1024x1536px-13d96239.jpg";